import React, { useEffect, useState } from 'react'
import { Box, BoxProps, styled, Typography } from '@mui/material'
import TractorLottie from '../assets/lottie/Tractor.json'
import { useLottie, LottieOptions } from 'lottie-react'

export const LoadingBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  margin: 'auto',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
})

interface Props extends BoxProps {
  title?: string
  type?: 'inline-flex' | 'flex'
}
export const Loader: React.FC<Props> = ({ title, type = 'flex', ...props }) => {
  const options: LottieOptions<'svg'> = {
    animationData: TractorLottie,
    loop: true,
    style: {
      height: type == 'inline-flex' ? '48px' : undefined,
    },
  }

  const { View } = useLottie(options)
  const [animationIndex, setAnimationIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimationIndex((prevIndex) => (prevIndex + 1) % 3)
    }, 300)

    return () => {
      clearInterval(interval)
    }
  }, [])

  const dots = Array.from({ length: 3 }, (_, index) => (
    <Typography
      key={index}
      variant='h4'
      component='span'
      style={{
        color: index == animationIndex ? 'rgba(0, 85, 61, 1.0)' : 'rgba(0, 85, 61, 0.33)',
      }}
    >
      .
    </Typography>
  ))

  if (type === 'flex') {
    return (
      <Box
        minWidth={250}
        display='flex'
        flexDirection='column'
        margin='auto'
        alignItems='center'
        {...props}
      >
        {title && (
          <Typography variant='h4' component='span' fontWeight='700' sx={{ mb: '16px' }}>
            {title}
            {dots}
          </Typography>
        )}
        <Box sx={{ maxWidth: '155px' }}>{View}</Box>
      </Box>
    )
  } else {
    return (
      <Box
        minWidth={250}
        display='inline-flex'
        alignItems={'center'}
        gap='16px'
        height='48px'
        {...props}
      >
        {title && (
          <Typography variant='h4' component='span' fontWeight='700'>
            {title}
            {dots}
          </Typography>
        )}
        <Box width={'70px'}>{View}</Box>
      </Box>
    )
  }
}
